import { render } from "./CollectTimeSlot.vue?vue&type=template&id=3f83bdb6"
import script from "./CollectTimeSlot.vue?vue&type=script&lang=js"
export * from "./CollectTimeSlot.vue?vue&type=script&lang=js"

import "./CollectTimeSlot.vue?vue&type=style&index=0&id=3f83bdb6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__